exports = module.exports = require("../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3ygtB{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._3ygtB:hover{opacity:.7}._2P21r{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2wxLm{position:relative;display:flex;align-items:center;justify-content:center}._1cMEP{width:26px;min-width:26px;height:26px;min-height:26px;transition:transform .2s}div[data-playable-hook=player-container][data-playable-in-full-screen=true] ._1cMEP{width:35px;min-width:35px;height:35px;min-height:21px}div[data-playable-hook=player-container][data-playable-in-full-screen=true] ._1cMEP ._16oii{width:21px;height:21px}._1cMEP ._16oii{width:14px;min-width:14px;height:14px;min-height:14px}._1cMEP:hover{transform:scale(1.18)}._1cMEP._3Ai_C:hover{transform:scale(.8)}", ""]);

// exports
exports.locals = {
	"controlButton": "_3ygtB",
	"hidden": "_2P21r",
	"pictureInPictureControl": "_2wxLm",
	"pictureInPictureToggle": "_1cMEP",
	"icon": "_16oii",
	"inPictureInPicture": "_3Ai_C"
};